import { Fragment } from 'react'
import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function AlertFeed({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:64px 0 0;display:flex;flex-direction:column")}>
      <div style={sx("padding:0 20px 20px;display:flex;flex-direction:column;gap:10px")}>
        <button onClick={v.backFromPush} style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);border:none;background:var(--bg-tertiary);cursor:pointer;display:flex;align-items:center;justify-content:center;margin-bottom:12px")}>
          <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat")} />
        </button>
        <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
          Alerts
        </span>
      </div>
      <div style={sx("flex:1;overflow:auto;padding:0 20px 20px;display:flex;flex-direction:column;gap:10px")}>
        {v.noAlertsYet ? (
          <>
            <div style={sx("margin-top:60px;display:flex;flex-direction:column;align-items:center;gap:10px;text-align:center;padding:0 24px")}>
              <span style={sx("width:56px;height:56px;border-radius:var(--radius-full);background:var(--bg-tertiary);display:flex;align-items:center;justify-content:center")}>
                <span style={sx("width:26px;height:26px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/bell.svg) center/contain no-repeat;mask:url(/assets/icons/bell.svg) center/contain no-repeat")} />
              </span>
              <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium)")}>
                Nothing to worry about
              </span>
              <span style={sx("font-size:var(--fs-sm);line-height:20px;color:var(--text-secondary)")}>
                Alerts about blocked threats show up here.
              </span>
            </div>
          </>
        ) : null}
        {v.alertRows.map((row, i) => (
          <Fragment key={i}>
            <div
              style={sx(
                `padding:16px;border-radius:var(--radius-md);background:var(--bg-secondary);` +
                  `border:1px solid ${row.border};display:flex;gap:12px;` +
                  `animation:gpop 250ms var(--ease-out)`
              )}
            >
              <span
                style={sx(
                  `width:40px;height:40px;flex:none;border-radius:var(--radius-full);` +
                    `background:${row.iconBg};display:flex;align-items:center;justify-content:center`
                )}
              >
                <span
                  style={sx(
                    `width:20px;height:20px;background:${row.accent};` +
                      `-webkit-mask:url(${row.icon}) center/contain no-repeat;` +
                      `mask:url(${row.icon}) center/contain no-repeat`
                  )}
                />
              </span>
              <span style={sx("flex:1;display:flex;flex-direction:column;gap:4px;min-width:0")}>
                <span style={sx("display:flex;justify-content:space-between;gap:8px;align-items:baseline")}>
                  <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
                    {row.title}
                  </span>
                  <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary);flex:none")}>
                    {row.time}
                  </span>
                </span>
                <span style={sx("font-size:var(--fs-xs);line-height:18px;color:var(--text-secondary)")}>
                  {row.detail}
                </span>
                <span style={sx("display:flex;align-items:center;gap:6px;margin-top:4px")}>
                  <span
                    style={sx(
                      `width:16px;height:16px;background:var(--text-secondary);` +
                        `-webkit-mask:url(${row.sourceIcon}) center/contain no-repeat;` +
                        `mask:url(${row.sourceIcon}) center/contain no-repeat`
                    )}
                  />
                  <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
                    {row.source}
                  </span>
                </span>

                {row.canRestore ? (
                  <button
                    onClick={row.restore}
                    style={sx(
                      "margin-top:8px;height:36px;border-radius:var(--radius-full);border:none;" +
                        "background:var(--bg-accent);color:#fff;font-family:inherit;" +
                        "font-size:var(--fs-xs);font-weight:var(--fw-medium);cursor:pointer"
                    )}
                  >
                    Turn it back on
                  </button>
                ) : null}

                {row.isResolved ? (
                  <span
                    style={sx(
                      "margin-top:8px;display:flex;align-items:center;gap:6px;" +
                        "font-size:var(--fs-2xs);color:var(--text-success)"
                    )}
                  >
                    <span
                      style={sx(
                        "width:14px;height:14px;background:var(--text-success);" +
                          "-webkit-mask:url(/assets/icons/checkmark.svg) center/contain no-repeat;" +
                          "mask:url(/assets/icons/checkmark.svg) center/contain no-repeat"
                      )}
                    />
                    Protection restored
                  </span>
                ) : null}
              </span>
            </div>
          </Fragment>
        ))}
        {v.hasAlerts ? (
          <>
            <div style={sx("padding:16px;border-radius:var(--radius-md);background:var(--bg-tertiary);display:flex;gap:12px")}>
              <span style={sx("width:18px;height:18px;flex:none;background:var(--text-secondary);-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;mask:url(/assets/icons/security-score.svg) center/contain no-repeat")} />
              <span style={sx("font-size:var(--fs-xs);line-height:18px;color:var(--text-secondary)")}>
                Your group blocked 1,284 trackers and 3 threats this week. Nothing needs your attention.
              </span>
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}
